import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import * as SystemActions from '../actions/system.action';

@Injectable()
export class SystemEffects {
  constructor(private readonly actions: Actions, private readonly router: Router) {}

  redirect$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(SystemActions.Redirect),
        tap(({ url }) => this.router.navigateByUrl(url))
      );
    },
    { dispatch: false }
  );

  redirectToCourtesyPage$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(SystemActions.RedirectToCourtesyPage),
        tap(() => {
          window.location.href = environment.b2cPolicies.redirectCourtesyPageUri;
        })
      );
    },
    { dispatch: false }
  );

  redirectToHomePage$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(SystemActions.RedirectToHomePage),
        tap(() => this.router.navigateByUrl('dias/homepage'))
      );
    },
    { dispatch: false }
  );

  openPage$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(SystemActions.OpenPage),
        tap(({ url, target }) => window.open(url, target))
      );
    },
    { dispatch: false }
  );
}
